export const useGeneralStore = defineStore('general', () => {
  const appSettings = ref<TNullable<TAppSettings>>()

  async function fetchAppSettings () {
    try {
      const response = await generalService.getAppSettings()
      appSettings.value = response
    } catch (error) {
      console.error(error)
    }
  }

  return {
    appSettings,
    fetchAppSettings
  }
})
